module.exports = __webpack_public_path__ + "img/produit_6.11339f13.png";